export default __webpack_public_path__ + "banner-framework-mbf49b20.png";